
(function() {
  var result = { translations: { "ro": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} ore", "hoursAndMinutes": "{{ hours }} ore {{ minutes }} min", "days": "{{ days }} zile", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}z", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ro": "static-7.820"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.820",
    "ar-eg": "static-7.820",
    "bg": "static-7.820",
    "bn": "static-7.820",
    "ca-es": "static-7.820",
    "cs": "static-7.820",
    "da": "static-7.820",
    "de": "static-7.820",
    "el": "static-7.820",
    "en-gb": "static-7.820",
    "en": "static-7.820",
    "es-mx": "static-7.820",
    "es": "static-7.820",
    "fi": "static-7.820",
    "fr-ca": "static-7.820",
    "fr": "static-7.820",
    "he-il": "static-7.820",
    "hr": "static-7.820",
    "hu": "static-7.820",
    "id": "static-7.820",
    "it": "static-7.820",
    "ja": "static-7.820",
    "ko": "static-7.820",
    "lt": "static-7.820",
    "ms": "static-7.820",
    "nl": "static-7.820",
    "no": "static-7.820",
    "pl": "static-7.820",
    "pt-br": "static-7.820",
    "pt-pt": "static-7.820",
    "ro": "static-7.820",
    "ru": "static-7.820",
    "sk": "static-7.820",
    "sl": "static-7.820",
    "sv": "static-7.820",
    "th": "static-7.820",
    "tl": "static-7.820",
    "tr": "static-7.820",
    "uk": "static-7.820",
    "vi": "static-7.820",
    "x-pseudo": "static-7.820",
    "zh-cn": "static-7.820",
    "zh-hk": "static-7.820",
    "zh-tw": "static-7.820"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ro', {version: 'static-7.820'}); }
})();


